import React, { PropsWithChildren } from "react";
import classNames from "classnames";

import btcWealthIon from "./images/btc-wealth-icon.png";
import ethStakingIcon from "./images/eth-staking-icon.png";
import { useMembershipPageContext } from "../../MembershipPage.context";
import { formatNumberToUSD } from "@features/utils/functions";

type FooterCardProps = {
  title: string;
  icon: string;
  className?: string;
};

type BitcoinInvestmentPlatformFooterProps = {
  isUk?: boolean;
};

const FooterCard = ({
  title,
  icon,
  className,
  children,
}: PropsWithChildren<FooterCardProps>) => {
  return (
    <div className={classNames("rounded-[16px] bg-[#F0EFFA] p-8", className)}>
      <div className="flex md:flex-row flex-col-reverse md:items-center justify-between mb-4">
        <h5 className="md:max-w-[75%] font-semibold mt-4 md:mt-0">{title}</h5>

        <img src={icon} alt="footer card icon" className="h-[55px] w-[55px]" />
      </div>

      <div className="md:max-w-[75%]">{children}</div>
    </div>
  );
};

export const BitcoinInvestmentPlatformFooter = ({
  isUk,
}: BitcoinInvestmentPlatformFooterProps) => {
  const { timelockMinValue } = useMembershipPageContext();
  return (
    <div id="ready-to-get-the-bitcoin-container">
      <FooterCard
        title={
          isUk
            ? "Ready to get the Bitcoin Wealth Builder Program (Valued at $5,000)?"
            : "Ready to get the Bitcoin Wealth Builder Program (Valued at $5,000) for FREE?"
        }
        icon={btcWealthIon}
        className="mb-4 mt-20"
      >
        <p className="mb-[16px]">
          The Bitcoin Wealth Builder Program is accessible only for Bnk To The
          Future investors who meet the qualifying criteria outlined in the
          “Track Your Progress” section below:
        </p>

        <p>
          Bnk To The Future has partnered with the Bitcoin Wealth Builder
          Program to offer a special promotion.&nbsp;
          {isUk
            ? "You can get the complimentary Bitcoin Wealth Builder Program when you invest a minimum $5,000 in ETH staking on Bnk To The Future and time-lock for a minimum of 1 year"
            : `You can receive the Bitcoin Wealth Builder Program (valued at $5,000) for FREE by investing a minimum of ${formatNumberToUSD(
                timelockMinValue
              )} in our ETH Staking Solution and selecting a minimum 1-year time lock.`}
          &nbsp;This solution provides weekly ETH income that can be converted
          to Bitcoin or compounded in ETH, helping investors grow their Bitcoin
          or ETH wealth every week.
        </p>
      </FooterCard>

      <FooterCard
        title="What is the BF ETH Staking Solution?"
        icon={ethStakingIcon}
      >
        <p>
          The BF ETH Staking Solution allows you to lock up your ETH and receive
          weekly income, leveraging the second-largest cryptocurrency's
          potential. As one of Bnk To The Future’s investment products, it's a
          key component in building and managing your Bitcoin & ETH Wealth.
          You'll explore this further in Module 5 of the Bitcoin Wealth Builder
          Program.
        </p>
      </FooterCard>

      <div className="md:mt-[80px] mt-[50px] text-center">
        <h5 className="mb-4 md:text-[14px] text-[20px]">
          Ready to get started?
        </h5>
        <p>
          {isUk
            ? "Below is a tracking tool to “Track Your Progress”, which aims to ensure a logical path to success in your Bitcoin Wealth Building journey."
            : "Below is a tracking tool to “Track Your Progress”, ensuring a smooth and logical path to success in your Bitcoin Wealth Building journey."}
        </p>
      </div>
    </div>
  );
};
